import developmentConfig from './env.development'
import productionConfig from './env.production'
import stagingConfig from './env.test'
import preConfig from './env.pre'

export interface IConfig {
  env: string // 开发环境
  mock?: boolean // mock数据
  title: string // 项目title
  baseUrl?: string // 项目地址
  baseApi?: string // api请求地址
  APPID?: string // 公众号appId  一般放在服务器端
  APPSECRET?: string // 公众号appScript 一般放在服务器端
  $cdn: string // cdn公共资源路径
}

// 根据环境引入不同配置 process.env.VUE_APP_SERVER_ENV
let config: IConfig = {
  env: 'development',
  title: 'title',
  $cdn: '',
}
if (process.env.VUE_APP_SERVER_ENV === 'development') {
  config = developmentConfig
} else if (process.env.VUE_APP_SERVER_ENV === 'test') {
  config = stagingConfig
} else if(process.env.VUE_APP_SERVER_ENV === 'pre'){
  config = preConfig
}else{
  config = productionConfig
}

export default config
